import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged, signOut, signInWithPhoneNumber } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import './App.css';

import SendOTP from './components/SendOTP';
import VerifyOTP from './components/VerifyOTP';
import Dashboard from './components/Dashboard';
import Members from './components/Members';
import Coaches from './components/Coaches';
import TitleUpdater from './components/TitleUpdater';

const VerifyOTPWrapper = ({ onLogin, onSendOTP }) => {
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;
  return <VerifyOTP onLogin={onLogin} onResendOTP={() => onSendOTP(phoneNumber)} />;
};

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists() && userDoc.data().roles && userDoc.data().roles.includes('admin')) {
          setUser(user);
          setIsAdmin(true);
        } else {
          setError('You are not authorized to access this application.');
          signOut(auth);
          setUser(null);
          setIsAdmin(false);
        }
      } else {
        setUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = (user) => {
    setUser(user);
  };

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser(null);
      setIsAdmin(false);
    });
  };

  const handleSendOTP = (phoneNumber) => {
    console.log("handleSendOTP called with:", phoneNumber);
    const appVerifier = window.recaptchaVerifier;
    return signInWithPhoneNumber(auth, phoneNumber, appVerifier);
  };

  if (loading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  return (
    <div className="App">
      <TitleUpdater />
      {error && <div className="error">{error}</div>}
      <Routes>
        <Route path="/" element={user && isAdmin ? <Navigate to="/dashboard" /> : <SendOTP onSendOTP={handleSendOTP} />} />
        <Route path="/verify-otp" element={user && isAdmin ? <Navigate to="/dashboard" /> : <VerifyOTPWrapper onLogin={handleLogin} onSendOTP={handleSendOTP} />} />
        <Route path="/dashboard" element={user && isAdmin ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/members" element={user && isAdmin ? <Members user={user} onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/coaches" element={user && isAdmin ? <Coaches user={user} onLogout={handleLogout} /> : <Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
